import { html } from 'htm/preact';

import Icon from './Icon';

const SectionHeader = ({ title, description, icon = null }) => {
  return html`
    <div class="flex flex-col items-center mb-3">
      ${icon && html`<${Icon} name=${icon} />`}
      <h3 class="flex h4 mb-2 normal-case text-center">${title}</h3>
      <p class="text-sm text-center">${description}</p>
    </div>
  `;
};

export default SectionHeader;
